const messages = {
  en: {
    cancel: 'Cancel',
    send: 'Send',
    sending: 'Sending...',
    name: 'Name',
    okey: 'Okey',
    email: 'Email',
    event_password: 'Event Password',
    registration: 'Registration',
    last_name: 'Last Name',
    city: 'City',
    'country/region': 'Country/Region',
    'zip/postal_code': 'Zip/Postal Code',
    'state/province': 'State/Province',
    phone: 'Phone',
    address: 'Address',
    speciality: 'Speciality',
    organization: 'Organization',
    job_title: 'Job Title',
    please_wait: 'Please Wait',
    no_event_found: 'No Event Found',
    join_now: 'Join Now',
    page_language: 'Website Language',
    type_your_question: 'Please type your question',
    this_event_is_not_started: 'This event is not started yet.',
    this_event_completed: 'This event has been concluded.',
    registration_required:
      'Registration is required for this event. Redirecting to registration page.',
  },
};

export default messages;
